import { render, staticRenderFns } from "./minister.vue?vue&type=template&id=23607b88&scoped=true&"
import script from "./minister.vue?vue&type=script&lang=js&"
export * from "./minister.vue?vue&type=script&lang=js&"
import style0 from "./minister.vue?vue&type=style&index=0&id=23607b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23607b88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
